export const CourseInstructorEndpoint = {
  courseInstructor: "ci",
  viewcourseInstructor: "ci/view",
  courseInstructorExportExcel: "ci/export/excel",
  isExists: "ci/isExists",
};
